module.exports = {"130628100":"高阳镇","130628101":"庞口镇","130628102":"西演镇","130628103":"邢家南镇","130628104":"晋庄镇","130628202":"蒲口乡","130628203":"小王果庄乡","130628204":"龙化乡","130628205":"庞家佐乡","130628400":"高阳县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130628.json
// module id = 146
// module chunks = 0